'use client'

import type { ProductLabelsProps } from '@maestro/commerce-blocks/components/product-labels/product-labels.types'
import type { Label } from '@maestro/data-layer'

import classNames from 'classnames'

import ProductLabel from '@maestro/commerce-blocks/components/product-labels/product-label'

import '@maestro/commerce-blocks/components/product-labels/styles/product-labels.scss'

export default function ProductLabels(props: ProductLabelsProps) {
  const { labels, className } = props

  if (!labels?.length) {
    return null
  }

  return (
    <div className={classNames('product-labels', className)}>
      {labels.map((label: Label) => {
        return <ProductLabel {...label} key={label.label} />
      })}
    </div>
  )
}
